export default __webpack_public_path__ + "static/media/feather _ chevron-down.21b24cf9.svg";